import Badge from 'react-bootstrap/Badge';
import { FormTextInput } from 'Components/Forms/FormInput.js';
import { Row, Card, Col, Form, Button } from "react-bootstrap";
import { http } from "Utils/http";
import { useEffect, useReducer, useState, useRef } from "react";
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import Stack from 'react-bootstrap/Stack';
import { loadFormInfo, submitCreateOrganizationData } from 'Components/Datatable/OrgAxiosFuncs'
import { useParams, useLocation, useNavigate } from 'react-router-dom';
//import { ACTIONS } from './RoleDataReducer';
import 'react-phone-input-2/lib/style.css'
import { TextButton } from 'Components/Button';
import { STATUSES, ERROR_MESSAGES, USER_ROLES, getFullUserRoleName, NUMBER_PATTERN } from "Utils/constants";
import { useDispatch } from "react-redux"

import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import 'react-phone-input-2';


import { setStatus, setPopup, setRedirect } from "Store/ErrorInfoSlice";

import { Link } from 'react-router-dom';
import { store } from 'Store';
import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { GetTextInputData, GetCheckboxInputData, GetDateInputData, GetPhoneInputData, GetSelectInputData, GetRadioInputData } from 'Containers/Private/Organization/Data files/OrganizationFields';
import { GetUserTextInputData, GetOrgTextInputData, GetUserCheckboxInputData, GetUserDateInputData, GetUserPhoneInputData, GetUserSelectInputData, GetUserRadioInputData, GetUserPasswordInputData } from 'Containers/Private/User/UserBeanFields';
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { RoleDataReducer } from "Containers/Private/User/RoleDataReducer";
import { getPrefixAndSuffixList, getRegionList } from 'Utils/utilityFunctions';
import { X } from '@mui/icons-material';
import { FormInputDisplay } from 'Components/Forms/FormInputDisplay.js';
import { displayErrors } from 'Components/Messages/ErrorMessage';

function EditUser () {
    //const [backRedirect, setBackRedirect] = useState(JSON.parse(localStorage.getItem('backRedirect')));

    //useEffect(() => {
    //    localStorage.setItem("backRedirect", JSON.stringify(backRedirect));
    //}, [backRedirect]);

    const ACTIONS = {
        CALL_API: 'call-api',
        SUCCESS: 'success',
        ERROR: 'error',
        SET_INITIAL_DATA: 'set-data',

        TEXT_CHANGE: 'text-change',
        TEXT_SET_ERRORS: 'text-set-errors',
        TEXT_REMOVE_ERRORS: 'text-remove-errors',

        RADIO_CHANGE: 'radio-change',
        RADIO_SET_ERRORS: 'radio-set-errors',
        RADIO_REMOVE_ERRORS: 'radio-remove-errors',

        SELECT_CHANGE: 'select-change',
        SELECT_SET_ERRORS: 'select-set-errors',
        SELECT_REMOVE_ERRORS: 'select-remove-errors',

        SET_INITIAL_CHECK_DATA: 'set-check-data',
        CHECK_CHANGE: 'check-change',
        CHECK_REQUIRED_CHANGE: 'check-required-change',
        CHECK_SET_ERRORS: 'check-set-errors',
        CHECK_REMOVE_ERRORS: 'check-remove-errors',

        DATE_CHANGE: 'date-change',
        DATE_SET_ERRORS: 'date-set-errors',
        DATE_REMOVE_ERRORS: 'date-remove-errors',

        PHONE_CHANGE: 'phone-change',
        PHONE_SET_ERRORS: 'phone-set-errors',
        PHONE_REMOVE_ERRORS: 'phone-remove-errors'
    };



    const invalidData = {

        roleId: USER_ROLES.LEVEL1.value,

        sftpRoleForLevel3: false,
        changeWSPwdRoleForLevel3: false,
        sftpRoleForPSOAdmin: false,
        changeWSPwdRoleForPSOAdmin: false,

        accessToCollabSite: true,

        firstname: "Heather",
        middlename: "",
        lastname: "Balke",
        prefix: "Mrs.",
        suffix: -1,
        credentials: "",
        jobTitle: "Web Developer",
        address1: "953 Humbert Ave.",
        address2: "",
        city: "San Luis Obispo",
        state: 5,
        zip: "93401",
        zipext: "",
        phoneForDisplay: "(805) 674-7154",
        phonextn: "",
        faxForDisplay: "",
        emailaddress: "hbalke805@gmail.com",
        confirmemailaddress: "hbalke805@gmail.com",
        certifiedcontactid: true,
        primarycontactid: false,
        //verifiedByUser : false,
    }

    let location = useLocation();

    const navigate = useNavigate();
    var passedData = location.state;
    const dispatch = useDispatch();

    //console.log(passedData);

    /*const psoId =  passedData.psoId;
    const orgName1 =  passedData.orgName;
    const organizationId =  passedData.orgId;
    const orgTypeId =  passedData.orgTypeId;
    const orgType= passedData.orgType;


    const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);*/

    const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);
    const orgType=backRedirect.state.orgType;
    
    const userId = passedData.userId;
    //const statusDesc = passedData.statusDesc;


    const [isLoading, setIsLoading] = useState(true);
    const [changeWSPwdRole, setChangeWSPwdRole] = useState(null);
    const [sftpRole, setSftpRole] = useState(null);
    const [accessToCollabSite, setAccessToCollabSite] = useState(null);
    const [orgTypeId, setOrgTypeId] = useState(null);
    //const [orgType, setOrgType] = useState(null);
    const [contactTypeVisibility, setContactTypeVisibility] = useState({ certifiedContactId: false, primaryContactId: false })
    const [orgId, setOrgId] = useState(backRedirect.state.id ? backRedirect.state.id : null);
    const [originalEmail, setOriginalEmail] = useState("");

    const [stateList, setStateList] = useState([]);
    const [prefixList, setPrefixList] = useState([]);
    const [suffixList, setSuffixList] = useState([]);

    var roleIdObj = {
        type: 'radio',
        name: "roleId",
        value: 0,
        validation: {
            required: true,
            isInvalid: false, //REPLACE
            errors: [],
            //isValid:false,
            successMsgs: []
        },
        //disabled: getVarValue(disabled),
        //readOnly: getVarValue(readOnly),
        //hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    }
    var roleCheckObj = {
        sftpRoleForLevel3: false,
        sftpRoleForPSOAdmin: false,
        changeWSPwdRoleForLevel3: false,
        changeWSPwdRoleForPSOAdmin: false
    };

    const [role, roleInputDispatch] = useReducer(RoleDataReducer, roleIdObj);
    const [roleCheck, roleCheckInputDispatch] = useReducer(RoleDataReducer, roleCheckObj);

    var [orgName, orgNameInputDispatch] = GetOrgTextInputData('name', '', orgType, 'create');
    var [orgPsoId, orgPsoIdInputDispatch] = GetOrgTextInputData('psoId', '', orgType, 'create');

    var [userStatus, userStatusInputDispatch] = GetUserRadioInputData('userStatus', '', orgType, 'edit');

    var [userFirstName, userFirstNameInputDispatch] = GetUserTextInputData('firstname', '', orgType, 'create');
    var [userMiddleName, userMiddleNameInputDispatch] = GetUserTextInputData('middlename', '', orgType, 'create');
    var [userLastName, userLastNameInputDispatch] = GetUserTextInputData('lastname', '', orgType, 'create');
    var [userPrefix, userPrefixInputDispatch] = GetUserSelectInputData('prefix', '', orgType, 'create');
    var [userSuffix, userSuffixInputDispatch] = GetUserSelectInputData('suffix', '', orgType, 'create');
    var [userCredentials, userCredentialsInputDispatch] = GetUserTextInputData('credentials', '', orgType, 'create');
    var [userJobTitle, userJobTitleInputDispatch] = GetUserTextInputData('jobTitle', '', orgType, 'create');
    var [userAddress1, userAddress1InputDispatch] = GetUserTextInputData('address1', '', orgType, 'create');
    var [userAddress2, userAddress2InputDispatch] = GetUserTextInputData('address2', '', orgType, 'create');
    var [userCity, userCityInputDispatch] = GetUserTextInputData('city', '', orgType, 'create');
    var [userState, userStateInputDispatch] = GetUserSelectInputData('state', '', orgType, 'create');
    var [userZip, userZipInputDispatch] = GetUserTextInputData('zip', '', orgType, 'create');
    var [userZipExt, userZipExtInputDispatch] = GetUserTextInputData('zipext', '', orgType, 'create');
    var [userPhone, userPhoneInputDispatch] = GetUserPhoneInputData('phoneForDisplay', '', orgType, 'create');
    var [userPhoneExt, userPhoneExtInputDispatch] = GetUserTextInputData('phonextn', '', orgType, 'create');
    var [userFax, userFaxInputDispatch] = GetUserPhoneInputData('faxForDisplay', '', orgType, 'create');
    var [userEmailAddress, userEmailAddressInputDispatch] = GetUserTextInputData('emailaddress', '', orgType, 'create');
    var [userConfirmEmailAddress, userConfirmEmailAddressInputDispatch] = GetUserTextInputData('confirmemailaddress', '', orgType, 'create');
    //var [userVerifiedByUser,userVerifiedByUserInputDispatch] = GetUserCheckboxInputData('verifiedByUser','',orgType,'create');
    var [userContactType, userContactTypeInputDispatch] = GetUserCheckboxInputData('contactType', '', orgType, 'create');
    var [userPassword, userPasswordInputDispatch] = GetUserPasswordInputData('editUserPassword', '', orgType, 'edit');

    const accessDisabledOn = () => {
        if (role.value == USER_ROLES.LEVEL1.value) {
            return true;
        }
        else {
            return false;
        }
    }
    const accessRequiredOn = () => {
        if (role.value == USER_ROLES.LEVEL1.value || role.value == USER_ROLES.AHRQUSER.value) {
            return true;
        }
        else {
            return false;
        }
    }
    var [accountRolesAdditionalAccess, accountRolesAdditionalAccessInputDispatch] = GetUserCheckboxInputData('accountRolesAdditionalAccess', '', orgType, 'create', accessDisabledOn);

    const setInitialData = (dispatch, value) => {
        //console.log("setinitialdata", value);
        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            value: value
        })
    }

    const setInitialSelectData = (dispatch, options) => {
        //console.log("setinitialselectdata", options);

        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            options: options
        })
    }

    const setInitialRadioData = (dispatch, radioButtons) => {
        //console.log("setinitialradiodata", radioButtons);

        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            radioButtons: radioButtons
        })
    }


    const errorHandle = function () {
        setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
                visible: true,
                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                showContactHelp: true
            },
            redirect: {
                redirect: false,
                redirectFirst: false,
                path: "",
                data: {}
            }
        })
    };

    const prefixAndSuffix = (errorHandle, value) => {
        getPrefixAndSuffixList(errorHandle, false).then((res) => {
            //console.log(res);
            if (res != null) {
                setInitialSelectData(userPrefixInputDispatch, res.prefixData);
                setInitialSelectData(userSuffixInputDispatch, res.suffixData);
                userPrefixInputDispatch({
                    type: ACTIONS.SELECT_CHANGE,
                    name: userPrefix.name,
                    value: value
                })
                userSuffixInputDispatch({
                    type: ACTIONS.SELECT_CHANGE,
                    name: userSuffix.name,
                    value: value
                })
            }
            return res;
        });
    }

    const region = (errorHandle, value) => {
        getRegionList(errorHandle, false).then((res) => {
            //console.log(res);
            if (res != null) {
                setInitialSelectData(userStateInputDispatch, res.stateData);
                userStateInputDispatch({
                    type: ACTIONS.SELECT_CHANGE,
                    name: userState.name,
                    value: value
                })
            }
            return res;
        });
    }

    const handleRoleInputRadioChange = (dispatch, e) => {
        var values = {
            sftpRoleForLevel3: false,
            sftpRoleForPSOAdmin: false,
            changeWSPwdRoleForLevel3: false,
            changeWSPwdRoleForPSOAdmin: false
        };
        if (e.target.value == USER_ROLES.LEVEL3.value) {
            if (roleCheck.sftpRoleForPSOAdmin == true) {
                values.sftpRoleForLevel3 = true;
            }
            if (roleCheck.changeWSPwdRoleForPSOAdmin == true) {
                values.changeWSPwdRoleForLevel3 = true;
            }
        }
        if (e.target.value == USER_ROLES.PSOADMIN.value) {
            if (roleCheck.sftpRoleForLevel3 == true) {
                values.sftpRoleForPSOAdmin = true;
            }
            if (roleCheck.changeWSPwdRoleForLevel3 == true) {
                values.changeWSPwdRoleForPSOAdmin = true;
            }
        }

        //console.log("RADIO-CHANGE");
        //console.log(e);

        dispatch({
            type: ACTIONS.RADIO_CHANGE,
            value: e.target.value,
            name: e.target.name
        });
        roleCheckInputDispatch({
            type: ACTIONS.SET_INITIAL_CHECK_DATA,
            data: values/*{
                sftpRoleForLevel3: false,
                sftpRoleForPSOAdmin: false,
                changeWSPwdRoleForLevel3: false,
                changeWSPwdRoleForPSOAdmin: false
            }*/
        });

        if (e.target.value == USER_ROLES.LEVEL1.value || e.target.value == USER_ROLES.AHRQUSER.value) {
            accountRolesAdditionalAccessInputDispatch({
                type: ACTIONS.CHECK_CHANGE,
                name: "collabSiteAccess",
                value: true,
                checked: true,
                disabled: true
            })
            accountRolesAdditionalAccessInputDispatch({
                type: ACTIONS.CHECK_CHANGE,
                name: "collabSiteAccess",
                required: true
            })
        }
        else {
            accountRolesAdditionalAccessInputDispatch({
                type: ACTIONS.CHECK_CHANGE,
                name: "collabSiteAccess",
                value: getFieldValue(accountRolesAdditionalAccess, 'collabSiteAccess'),
                checked: getFieldValue(accountRolesAdditionalAccess, 'collabSiteAccess'),
                disabled: false
            })
            accountRolesAdditionalAccessInputDispatch({
                type: ACTIONS.CHECK_CHANGE,
                name: "collabSiteAccess",
                required: false
            })
        }
    }

    const handleRoleInputRadioChangeSet = (dispatch, data) => {
        var values = {
            sftpRoleForLevel3: false,
            sftpRoleForPSOAdmin: false,
            changeWSPwdRoleForLevel3: false,
            changeWSPwdRoleForPSOAdmin: false
        };


        if (data.value == USER_ROLES.LEVEL3.value) {
            if (roleCheck.sftpRoleForPSOAdmin == true) {
                values.sftpRoleForLevel3 = true;
            }
            if (roleCheck.changeWSPwdRoleForPSOAdmin == true) {
                values.changeWSPwdRoleForLevel3 = true;
            }
        }
        if (data.value == USER_ROLES.PSOADMIN.value) {
            if (roleCheck.sftpRoleForLevel3 == true) {
                values.sftpRoleForPSOAdmin = true;
            }
            if (roleCheck.changeWSPwdRoleForLevel3 == true) {
                values.changeWSPwdRoleForPSOAdmin = true;
            }
        }

        //console.log("RADIO-CHANGE");
        //console.log(data);

        dispatch({
            type: ACTIONS.RADIO_CHANGE,
            value: data.value,
            name: data.name
        });
        roleCheckInputDispatch({
            type: ACTIONS.SET_INITIAL_CHECK_DATA,
            data: values/*{
                sftpRoleForLevel3: false,
                sftpRoleForPSOAdmin: false,
                changeWSPwdRoleForLevel3: false,
                changeWSPwdRoleForPSOAdmin: false
            }*/
        });

        if (data.value == USER_ROLES.LEVEL1.value || data.value == USER_ROLES.AHRQUSER.value) {
            accountRolesAdditionalAccessInputDispatch({
                type: ACTIONS.CHECK_CHANGE,
                name: "collabSiteAccess",
                value: true,
                checked: true,
                disabled: true
            })
            accountRolesAdditionalAccessInputDispatch({
                type: ACTIONS.CHECK_CHANGE,
                name: "collabSiteAccess",
                required: true
            })
        }
        else {
            accountRolesAdditionalAccessInputDispatch({
                type: ACTIONS.CHECK_CHANGE,
                name: "collabSiteAccess",
                value: getFieldValue(accountRolesAdditionalAccess, 'collabSiteAccess'),
                checked: getFieldValue(accountRolesAdditionalAccess, 'collabSiteAccess'),
                disabled: false
            })
            accountRolesAdditionalAccessInputDispatch({
                type: ACTIONS.CHECK_CHANGE,
                name: "collabSiteAccess",
                required: false
            })
        }
    }

    const handleInputCheckChange = (dispatch, e) => {
        //console.log("print out checkbox change", e);
        //console.log(e.target.id);
        dispatch({
            type: ACTIONS.CHECK_CHANGE,
            name: e.target.name,
            value: e.target.value,
            checked: e.target.checked,
            disabled: false
        })
    }

    function getFieldValue (object, name) {
        //console.log(object);
        /*if(formInfo.loading){
            return '';
        }
        else{*/
        var type = object.type;
        switch (type) {
            case "text":
                if (object.value != null) {
                    return object.value;
                }
                return "";
            case "password":
                if (object.value != null) {
                    return object.value;
                }
                return "";
            case "date":
                if (object.value != null) {
                    var split = object.value.split('-');
                    //console.log(split);
                    if (split.length == 3) {
                        return split[1] + '/' + split[2] + '/' + split[0];
                    }
                    return object.value;
                }
                return "";
            case "select":
                if (object != null) {
                    var arr = object.options;
                    //console.log("ARR");
                    //console.log(arr);
                    for (var x = 0; x < arr.length; x++) {
                        var val = arr[x];
                        if (val.isSelected) {
                            return val.value;
                        }
                    }
                }
                return null;
            case "radio":
                if (object != null) {
                    var arr = object.radioButtons;
                    for (var x = 0; x < arr.length; x++) {
                        if (arr[x].isChecked) {
                            return arr[x].value;
                        }
                    }
                }
                return null;
            case "checkbox":
                if (object != null) {
                    var arr = object.checkBoxes;
                    //console.log("checkbox");
                    //console.log(arr);

                    for (var x = 0; x < arr.length; x++) {
                        if (arr[x].isChecked && arr[x].name == name) {
                            return arr[x].isChecked;
                        }
                    }

                }
                return false;
            case "tel":
                if (object.value != null) {
                    return object.value;
                }
                return "";
            default:
                return "";
        }
        //}

    }


    const fieldDataAccess = {
        psoId: { value: orgPsoId, dispatch: orgPsoIdInputDispatch },
        orgname: { value: orgName, dispatch: orgNameInputDispatch },

        roleId: { value: role, dispatch: roleInputDispatch },
        sftpRoleForLevel3: { value: roleCheck.sftpRoleForLevel3, dispatch: roleCheckInputDispatch },
        changeWSPwdRoleForLevel3: { value: roleCheck.changeWSPwdRoleForLevel3, dispatch: roleCheckInputDispatch },

        sftpRoleForPSOAdmin: { value: roleCheck.sftpRoleForPSOAdmin, dispatch: roleCheckInputDispatch },
        changeWSPwdRoleForPSOAdmin: { value: roleCheck.changeWSPwdRoleForPSOAdmin, dispatch: roleCheckInputDispatch },

        accessToCollabSite: { value: accountRolesAdditionalAccess, dispatch: accountRolesAdditionalAccessInputDispatch },

        firstname: { value: userFirstName, dispatch: userFirstNameInputDispatch },
        middlename: { value: userMiddleName, dispatch: userMiddleNameInputDispatch },
        lastname: { value: userLastName, dispatch: userLastNameInputDispatch },
        prefix: { value: userPrefix, dispatch: userPrefixInputDispatch },
        suffix: { value: userSuffix, dispatch: userSuffixInputDispatch },
        credentials: { value: userCredentials, dispatch: userCredentialsInputDispatch },
        jobTitle: { value: userJobTitle, dispatch: userJobTitleInputDispatch },
        address1: { value: userAddress1, dispatch: userAddress1InputDispatch },
        address2: { value: userAddress2, dispatch: userAddress2InputDispatch },
        city: { value: userCity, dispatch: userCityInputDispatch },
        state: { value: userState, dispatch: userStateInputDispatch },
        zip: { value: userZip, dispatch: userZipInputDispatch },
        zipext: { value: userZipExt, dispatch: userZipExtInputDispatch },
        phoneForDisplay: { value: userPhone, dispatch: userPhoneInputDispatch },
        phonextn: { value: userPhoneExt, dispatch: userPhoneExtInputDispatch },
        faxForDisplay: { value: userFax, dispatch: userFaxInputDispatch },
        emailaddress: { value: userEmailAddress, dispatch: userEmailAddressInputDispatch },
        confirmemailaddress: { value: userConfirmEmailAddress, dispatch: userConfirmEmailAddressInputDispatch },
        certifiedcontactid: { value: userContactType, dispatch: userContactTypeInputDispatch },
        primarycontactid: { value: userContactType, dispatch: userContactTypeInputDispatch },
        //verifiedByUser : { value: userVerifiedByUser, dispatch: userVerifiedByUserInputDispatch},


        editUserPassword: { value: userPassword, dispatch: userPasswordInputDispatch }

        /* 'firstname': userFirstName,
         'middlename': userMiddleName,
         'lastname': userLastName,
         'prefixId': userPrefix,
         'suffixId': userSuffix,
         'credentials': userCredentials,
         'jobTitle': userJobTitle,
         'address1': userAddress1,
         'address2': userAddress2,
         'city': userCity,
         'state': userState,
         'zip': userZip,
         'zipext': userZipExt,
         'phoneForDisplay': userPhone,
         'phonextn': userPhoneExt,
         'faxForDisplay': userFax,
         'emailaddress': userEmailAddress,
         'confirmemailaddress': userConfirmEmailAddress,
         'certifiedcontactid': userContactType,
         'primarycontactid': userContactType,
         'verifiedByUser': userVertifiedByUser,
 
         'sftpRoleForLevel3': roleCheck,
         'sftpRoleForPSOAdmin': roleCheck,
         'changeWSPwdRoleForLevel3': roleCheck,
         'changeWSPwdRoleForPSOAdmin': roleCheck,
 
         'accessToCollabSite': accountRolesAdditionalAccess,
 
         'roleId': role,
 
         'orgname': orgName,
         'psoId': orgPsoId,*/
    }

    function addErrorMessages (object, fieldErrors, dispatch, isFirst) {
        //console.log("ADD ERROR MESSAGES");
        //console.log(object);
        //console.log(fieldErrors);
        var err = [];
        var type = object.type;

        if (fieldErrors != null) {
            err = fieldErrors.errorMessages;

            if (isFirst == true) {
                (object.InputRef).current.focus();
                //console.log("ISFIRST");
            }
        }


        switch (type) {
            case "text":
                dispatch({
                    type: ACTIONS.TEXT_SET_ERRORS,
                    errors: err
                })
                break;
            case "date":
                dispatch({
                    type: ACTIONS.TEXT_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
            case "select":
                dispatch({
                    type: ACTIONS.SELECT_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
            case "radio":
                dispatch({
                    type: ACTIONS.RADIO_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
            case "checkbox":
                dispatch({
                    type: ACTIONS.CHECK_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
            case "tel":
                dispatch({
                    type: ACTIONS.PHONE_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
            case "password":
                dispatch({
                    type: ACTIONS.TEXT_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
        }
    }

    function setTestData (object, value, dispatch) {
        //console.log("ADD TEST DATA");
        //console.log(object);
        //console.log(value);

        //if(value != null){

        var type = object.type;

        switch (type) {
            case "text":
                dispatch({
                    type: ACTIONS.TEXT_CHANGE,
                    name: value.name,
                    value: value
                })
                break;
            case "date":
                dispatch({
                    type: ACTIONS.TEXT_CHANGE,
                    name: value.name,
                    value: value
                })
                break;
            case "select":
                dispatch({
                    type: ACTIONS.SELECT_CHANGE,
                    name: value.name,
                    value: value
                })
                break;
            case "radio":
                dispatch({
                    type: ACTIONS.RADIO_CHANGE,
                    name: value.name,
                    value: value
                })
                break;
            case "checkbox":
                dispatch({
                    type: ACTIONS.CHECK_CHANGE,
                    name: value.name,
                    value: value
                })
                break;
            case "tel":
                dispatch({
                    type: ACTIONS.PHONE_CHANGE,
                    name: value.name,
                    value: value
                })
                break;
        }

        //}
    }


    function enterData () {
        for (const [key, value] of Object.entries(fieldDataAccess)) {
            //console.log("Key: " + key + "Value: ");
            //console.log(value);

            var data = invalidData[key];
            //console.log("VALUE-ENTERDATA");
            //console.log(data);

            if (data != null) {
                var disp = value.dispatch;
                var obj = value.value;
                setTestData(obj, data, disp);
            }


        }

    }

    /*function clearErrorMessages (data) {
        for (const [key, value] of Object.entries(data)) {
            var t = formFieldDisplay[key];
            var fieldName = key;
            switch (t.type){
                case "text":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "date":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "select":
                    formInfoDispatch({
                        type: ACTIONS.SELECT_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "radio":
                    formInfoDispatch({
                        type: ACTIONS.RADIO_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "checkbox":
                    formInfoDispatch({
                        type: ACTIONS.CHECK_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "text":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
            }

        }  
    }*/


    const handleCancel = async () => {
        if (backRedirect.path == null) {
            setBackRedirect("/manage/user");
        }
        //localStorage.setItem('state', JSON.stringify(backRedirect.state));
        navigate(
            backRedirect.path,
            { state: backRedirect.state }
        );
        //clearErrorMessages(formInfo.data);
    };


    const loadUserData = async () => {

        //console.log("viewUser");
        var url = '/api/manage/users/edituser';
        var values = {
            userId: userId
        }

        //console.log(values);
        setIsLoading(true);
        const loginState = store.getState().loginInfo;
        const res = http.post(url, values, {
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            if (response != null) {
                //console.log(response);
                var statusCode = response.status;
                if (statusCode != 1) {
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.GENERAL_ERROR.title,
                            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                            showContactHelp: true
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    });
                }
                else {

                    //setOrgType();
                    setOrgTypeId(response.data.orgTypeId);
                    prefixAndSuffix(errorHandle, { prefixId: response.data.prefixId, suffixId: response.data.suffixId });
                    region(errorHandle, response.data.state);
                    setOrgId(response.data.organizationId);

                    userStatusInputDispatch({
                        type: ACTIONS.RADIO_CHANGE,
                        value: response.data.statusId
                    })

                    setOriginalEmail(response.data.originalUserEmail);

                    setInitialData(orgNameInputDispatch, response.data.orgname);
                    setInitialData(orgPsoIdInputDispatch, response.data.psoId);
                    setInitialData(userFirstNameInputDispatch, response.data.firstname);
                    setInitialData(userMiddleNameInputDispatch, response.data.middlename);
                    setInitialData(userLastNameInputDispatch, response.data.lastname);

                    setInitialData(userCredentialsInputDispatch, response.data.credentials);
                    setInitialData(userJobTitleInputDispatch, response.data.jobTitle);
                    setInitialData(userAddress1InputDispatch, response.data.address1);
                    setInitialData(userAddress2InputDispatch, response.data.address2);
                    setInitialData(userCityInputDispatch, response.data.city);

                    setInitialData(userZipInputDispatch, response.data.zip);
                    setInitialData(userZipExtInputDispatch, response.data.zipext);
                    setInitialData(userPhoneInputDispatch, response.data.phoneForDisplay);
                    setInitialData(userPhoneExtInputDispatch, response.data.phonextn);
                    //setInitialData(userFaxInputDispatch, response.data.faxForDisplay);

                    var faxVal = response.data.faxForDisplay;
                    if (faxVal == null) {
                        faxVal = "";
                    }
                    userFaxInputDispatch({
                        type: ACTIONS.PHONE_CHANGE,
                        value: faxVal
                    })

                    setInitialData(userEmailAddressInputDispatch, response.data.emailaddress);
                    setInitialData(userConfirmEmailAddressInputDispatch, response.data.confirmemailaddress);

                    //setInitialData(userContactTypeInputDispatch, response.data.certifiedcontactid);
                    //setInitialData(userContactTypeInputDispatch, response.data.primarycontactid);


                    setContactTypeVisibility({ primaryContactId: response.data.primarycontactid, certifiedContactId: response.data.certifiedcontactid })

                    userContactTypeInputDispatch({
                        type: ACTIONS.CHECK_CHANGE,
                        name: 'certifiedcontactid',
                        value: response.data.certifiedcontactid,
                        checked: response.data.certifiedcontactid
                    })

                    userContactTypeInputDispatch({
                        type: ACTIONS.CHECK_CHANGE,
                        name: 'primarycontactid',
                        value: response.data.primarycontactid,
                        checked: response.data.primarycontactid
                    })

                    userContactTypeInputDispatch({
                        type: ACTIONS.CHECK_REMOVE_FALSE
                    })

                    //setInitialData(roleCheckInputDispatch, response.data.sftpRoleForLevel3);
                    //setInitialData(roleCheckInputDispatch, response.data.sftpRoleForPSOAdmin);
                    //setInitialData(roleCheckInputDispatch, response.data.changeWSPwdRoleForLevel3);
                    //setInitialData(roleCheckInputDispatch, response.data.changeWSPwdRoleForPSOAdmin);
                    handleRoleInputRadioChangeSet(roleInputDispatch, { name: role.name, value: response.data.roleId });

                    roleCheckInputDispatch({
                        type: ACTIONS.SET_INITIAL_CHECK_DATA,
                        data: {
                            sftpRoleForLevel3: response.data.sftpRoleForLevel3,
                            sftpRoleForPSOAdmin: response.data.sftpRoleForPSOAdmin,
                            changeWSPwdRoleForLevel3: response.data.changeWSPwdRoleForLevel3,
                            changeWSPwdRoleForPSOAdmin: response.data.changeWSPwdRoleForPSOAdmin
                        }
                    });



                    //setChangeWSPwdRole(response.data.changeWSPwdRole);
                    //setSftpRole(response.data.sftpRole);
                    //setAccessToCollabSite(response.data.accessToCollabSite);


                    //setInitialData(accountRolesAdditionalAccessInputDispatch, response.data.accessToCollabSite);

                    //setInitialData(roleInputDispatch, response.data.roleId);
                    /*roleInputDispatch({
                        type: ACTIONS.RADIO_CHANGE,
                        name: role.name,
                        value: response.data.roleId
                    })*/


                    accountRolesAdditionalAccessInputDispatch({
                        type: ACTIONS.CHECK_CHANGE,
                        name: "collabSiteAccess",
                        value: response.data.accessToCollabSite,
                        checked: response.data.accessToCollabSite
                    })
                    setIsLoading(false);

                }

            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
                //dispatch(setStatus(STATUSES.ERROR));
                //dispatch(setPopup({visible: true, title: ERROR_MESSAGES.DATA_ERROR.title, msg: ERROR_MESSAGES.DATA_ERROR.message, showContactHelp: true }));
            }
        }).catch(function (error) {
            //console.log(error);
            //setIsLoading(false);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        //console.log(res);
        return res;

    };

    const handleSubmit = async () => {

        //console.log("submitUser");
        var url = '/api/manage/users/updateuser';
        var values = {
            firstname: getFieldValue(userFirstName, null),
            middlename: getFieldValue(userMiddleName, null),
            lastname: getFieldValue(userLastName, null),
            prefix: getFieldValue(userPrefix, null),
            suffix: getFieldValue(userSuffix, null),
            credentials: getFieldValue(userCredentials, null),
            jobTitle: getFieldValue(userJobTitle, null),
            address1: getFieldValue(userAddress1, null),
            address2: getFieldValue(userAddress2, null),
            city: getFieldValue(userCity, null),
            state: getFieldValue(userState, null),
            zip: getFieldValue(userZip, null),
            zipext: getFieldValue(userZipExt, null),
            phoneForDisplay: getFieldValue(userPhone, null),
            phonextn: getFieldValue(userPhoneExt, null),
            faxForDisplay: getFieldValue(userFax, null),
            emailaddress: getFieldValue(userEmailAddress, null),
            confirmemailaddress: getFieldValue(userConfirmEmailAddress, null),
            originalUserEmail: originalEmail,//getFieldValue(userConfirmEmailAddress,null),
            certifiedcontactid: getFieldValue(userContactType, 'certifiedcontactid'),
            primarycontactid: getFieldValue(userContactType, 'primarycontactid'),
            //verifiedByUser : getFieldValue(userVerifiedByUser,'contactVerify'),
            statusId: getFieldValue(userStatus, null),
            sftpRoleForLevel3: roleCheck.sftpRoleForLevel3,
            sftpRoleForPSOAdmin: roleCheck.sftpRoleForPSOAdmin,
            changeWSPwdRoleForLevel3: roleCheck.changeWSPwdRoleForLevel3,
            changeWSPwdRoleForPSOAdmin: roleCheck.changeWSPwdRoleForPSOAdmin,
            editUserPassword: getFieldValue(userPassword, null),
            accessToCollabSite: getFieldValue(accountRolesAdditionalAccess, 'collabSiteAccess'),

            roleId: role.value,

            organizationId: orgId,
            orgname: getFieldValue(orgName, null),
            orgTypeId: orgTypeId,
            psoId: getFieldValue(orgPsoId, null),
            userId: userId


        }

        //console.log(values);
        const loginState = store.getState().loginInfo;
        const res = http.post(url, values, {
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            if (response != null) {
                //console.log(response);
                var statusCode = response.status;
                if (statusCode != 1) {
                    var d = response.fieldErrors;
                    var x = 0;
                    var isFirst = false;
                    for (const [key, value] of Object.entries(fieldDataAccess)) {
                        //console.log("Key: " + key + "Value: ");
                        //console.log(value);
                        //console.log(d);

                        var values = d[key];
                        //console.log("VALUES");
                        //console.log(values);
                        var disp = value.dispatch;
                        var obj = value.value;
                        if (values != null) {



                            if (x == 0) {
                                isFirst = true;
                            }
                            else {
                                isFirst = false;
                            }
                            addErrorMessages(obj, values, disp, isFirst);
                            x = x + 1;
                        }
                        else {
                            addErrorMessages(obj, null, disp, false);
                        }
                    }

                    if (response.globalErrorMessageList && response.globalErrorMessageList.length > 0) {
                        setGlobalErrorStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                                msg: response.globalErrorMessageList,
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: false,
                                redirectFirst: false,
                                path: "",
                                data: {}
                            }
                        });
                    }
                }
                else {
                    if (backRedirect.path == null) {
                        setBackRedirect("/manage/user");
                    }
                    //localStorage.setItem('state', JSON.stringify(backRedirect.state));


                    setGlobalSuccessStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: "Success!",
                            msg: "User has been sucessfully updated.",
                            showContactHelp: false
                        },
                        redirect: {
                            redirect: true,
                            redirectFirst: true,
                            path: backRedirect.path,
                            data: backRedirect.state 
                        }

                    });
                }

            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
                //dispatch(setStatus(STATUSES.ERROR));
                //dispatch(setPopup({visible: true, title: ERROR_MESSAGES.DATA_ERROR.title, msg: ERROR_MESSAGES.DATA_ERROR.message, showContactHelp: true }));
            }
        }).catch(function (error) {
            //console.log(error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        //console.log(res);
        return res;
    };

    /*var displayErrors = (fieldData) => {
        return (
            <div>
                {fieldData.validation.errors.length > 0 ? fieldData.validation.errors.map((errorText,index) => 
                    <Stack key={fieldData.name + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                        <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                        <div>{errorText}</div>
                    </Stack>
                    
                ) : null}
            </div>
        );
    }*/

    useEffect(() => {
        loadUserData();
    }, []);
    useEffect(() => {
        //console.log("useEffect");
        userEmailAddressInputDispatch({
            type: ACTIONS.TEXT_CHANGE,
            name: userEmailAddress.name,
            value: userEmailAddress.value
        });
    }, [userConfirmEmailAddress.value])


    return (
        <Row >
            {
                /*formInfo.loading ? 
                    null
                    :  */
                <Row >
                    <Col xl={11} lg={11} md={11} sm={12}>
                        <Card className="p-4" >
                            <Card.Body className="text-start">

                                <Row>
                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold">Edit User</h1>
                                    <p>To edit user information, enter the required information below.</p>
                                </Row>
                                <Row>
                                    {/*<Button onClick={enterData}>Test</Button>*/}
                                    <Form>

                                        <h2>Organization Information</h2>
                                        {/*
                                            Organization Name
                                            Organization ID
                                        */}
                                        <FormInputDisplay fieldData={orgName} inputDispatch={orgNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={orgPsoId} inputDispatch={orgPsoIdInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>

                                        <h2>Account Status</h2>
                                        <FormInputDisplay fieldData={userStatus} inputDispatch={userStatusInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={true} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 8 } }}></FormInputDisplay>

                                        <h2>Account Roles</h2>
                                        <fieldset>

                                            <Form.Group as={Row} className="mb-3 accountRolesInput">
                                                <Col hidden={true}
                                                /*xs={getColLabelSizes('xs')} 
                                                sm={getColLabelSizes('sm')} 
                                                md={getColLabelSizes('md')} 
                                                lg={getColLabelSizes('lg')} 
                                                xl={getColLabelSizes('xl')} 
                                                xxl={getColLabelSizes('xxl')} */
                                                >
                                                    <legend>
                                                        {<span className="me-2">Account Roles</span>}
                                                        {/*fieldData.validation.required ? '' : <Badge bg="optional">Optional</Badge>*/}
                                                    </legend>
                                                </Col>

                                                <Col
                                                /*xs={getColSize("inputCols",'xs')} 
                                                sm={getColSize("inputCols",'sm')} 
                                                md={getColSize("inputCols",'md')} 
                                                lg={getColSize("inputCols",'lg')} 
                                                xl={getColSize("inputCols",'xl')} 
                                                xxl={getColSize("inputCols",'xxl')} */
                                                >
                                                    {orgTypeId == 24
                                                        ? <>
                                                            <Form.Check
                                                                key={"roleIdLevel1"}
                                                                type="radio"
                                                                id={"roleIdLevel1"}

                                                                label={getFullUserRoleName(USER_ROLES.LEVEL1.name, USER_ROLES.LEVEL1.includes)}//{"Level 1 (PSO Collaboration Community Access)"}
                                                                name={role.name}
                                                                value={USER_ROLES.LEVEL1.value}
                                                                onChange={(e) => handleRoleInputRadioChange(roleInputDispatch, e)}
                                                                checked={USER_ROLES.LEVEL1.value == role.value}
                                                                //isInvalid={role.validation.isInvalid  == true ? true : false}
                                                                //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                ref={role.InputRef}
                                                            />
                                                            <Form.Check
                                                                key={"roleIdLevel2"}
                                                                type="radio"
                                                                id={"roleIdLevel2"}

                                                                label={getFullUserRoleName(USER_ROLES.LEVEL2.name, USER_ROLES.LEVEL2.includes)}
                                                                name={role.name}
                                                                value={USER_ROLES.LEVEL2.value}
                                                                onChange={(e) => handleRoleInputRadioChange(roleInputDispatch, e)}
                                                                checked={USER_ROLES.LEVEL2.value == role.value}
                                                                //isInvalid={role.validation.isInvalid == true ? "invalid" : ""}
                                                                //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                ref={role.InputRef}
                                                            />
                                                        </>
                                                        : null
                                                    }
                                                    {orgTypeId == 24 || orgTypeId == 26
                                                        ? <>
                                                            <Form.Check
                                                                key={"roleIdLevel3"}
                                                                type="radio"
                                                                id={"roleIdLevel3"}

                                                                label={getFullUserRoleName(USER_ROLES.LEVEL3.name, USER_ROLES.LEVEL3.includes)}
                                                                name={role.name}
                                                                value={USER_ROLES.LEVEL3.value}
                                                                onChange={(e) => handleRoleInputRadioChange(roleInputDispatch, e)}
                                                                checked={USER_ROLES.LEVEL3.value == role.value}
                                                                //isInvalid={role.validation.isInvalid  == true  ? "invalid" : ""}
                                                                //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                ref={role.InputRef}
                                                            />
                                                            {USER_ROLES.LEVEL3.value == role.value
                                                                ?
                                                                <Row className="indented-checkbox">
                                                                    <Form.Check
                                                                        key={"roleIdLevel3SFTP"}
                                                                        type="checkbox"
                                                                        id={"roleIdLevel3SFTP"}

                                                                        label={"Receive SFTP Email"}
                                                                        name={"sftpRoleForLevel3"}
                                                                        value={false}
                                                                        onChange={(e) => handleInputCheckChange(roleCheckInputDispatch, e)}
                                                                        checked={roleCheck.sftpRoleForLevel3}
                                                                    //isInvalid={fieldData.validation.isInvalid? "invalid":""}
                                                                    //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                    //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                    //ref={fieldData.InputRef}
                                                                    />
                                                                    <Form.Check
                                                                        key={"roleIdLevel3WSPass"}
                                                                        type="checkbox"
                                                                        id={"roleIdLevel3WSPass"}

                                                                        label={"Change Web Service Account Password"}
                                                                        name={"changeWSPwdRoleForLevel3"}
                                                                        value={false}
                                                                        onChange={(e) => handleInputCheckChange(roleCheckInputDispatch, e)}
                                                                        checked={roleCheck.changeWSPwdRoleForLevel3}
                                                                    //isInvalid={fieldData.validation.isInvalid? "invalid":""}
                                                                    //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                    //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                    //ref={fieldData.InputRef}
                                                                    />
                                                                </Row>
                                                                : null
                                                            }
                                                        </>
                                                        : null
                                                    }

                                                    {orgTypeId == 24
                                                        ? <>
                                                            <Form.Check
                                                                key={"roleIdPSOAdmin"}
                                                                type="radio"
                                                                id={"roleIdPSOAdmin"}

                                                                label={getFullUserRoleName(USER_ROLES.PSOADMIN.name, USER_ROLES.PSOADMIN.includes)}
                                                                name={role.name}
                                                                value={USER_ROLES.PSOADMIN.value}
                                                                onChange={(e) => handleRoleInputRadioChange(roleInputDispatch, e)}
                                                                checked={USER_ROLES.PSOADMIN.value == role.value}
                                                                //isInvalid={role.validation.isInvalid  == true ? "invalid" : ""}
                                                                //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                ref={role.InputRef}
                                                            />
                                                            {USER_ROLES.PSOADMIN.value == role.value
                                                                ? <Row className="indented-checkbox">
                                                                    <Form.Check
                                                                        key={"roleIdPSOAdminSFTP"}
                                                                        type="checkbox"
                                                                        id={"roleIdPSOAdminSFTP"}

                                                                        label={"Receive SFTP Email"}
                                                                        name={"sftpRoleForPSOAdmin"}
                                                                        value={false}
                                                                        onChange={(e) => handleInputCheckChange(roleCheckInputDispatch, e)}
                                                                        checked={roleCheck.sftpRoleForPSOAdmin}
                                                                    //isInvalid={fieldData.validation.isInvalid? "invalid":""}
                                                                    //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                    //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                    //ref={fieldData.InputRef}
                                                                    />
                                                                    <Form.Check
                                                                        key={"roleIdPSOAdminWSPass"}
                                                                        type="checkbox"
                                                                        id={"roleIdPSOAdminWSPass"}

                                                                        label={"Change Web Service Account Password"}
                                                                        name={"changeWSPwdRoleForPSOAdmin"}
                                                                        value={false}
                                                                        onChange={(e) => handleInputCheckChange(roleCheckInputDispatch, e)}
                                                                        checked={roleCheck.changeWSPwdRoleForPSOAdmin}
                                                                    //isInvalid={fieldData.validation.isInvalid? "invalid":""}
                                                                    //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                    //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                    //ref={fieldData.InputRef}
                                                                    />
                                                                </Row>
                                                                : null
                                                            }
                                                        </>
                                                        : null
                                                    }


                                                    {orgTypeId == 25
                                                        ? <>
                                                            <Form.Check
                                                                key={"roleIdPSOPPCAdmin"}
                                                                type="radio"
                                                                id={"roleIdPSOPPCAdmin"}

                                                                label={getFullUserRoleName(USER_ROLES.PSOPPCADMIN.name, USER_ROLES.PSOPPCADMIN.includes)} name={role.name}
                                                                value={USER_ROLES.PSOPPCADMIN.value}
                                                                onChange={(e) => handleRoleInputRadioChange(roleInputDispatch, e)}
                                                                checked={USER_ROLES.PSOPPCADMIN.value == role.value}
                                                                //isInvalid={role.validation.isInvalid  == true ? "invalid" : ""}
                                                                //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                ref={role.InputRef}
                                                            />
                                                            <Form.Check
                                                                key={"roleIdPSOPPCManager"}
                                                                type="radio"
                                                                id={"roleIdPSOPPCManager"}

                                                                label={getFullUserRoleName(USER_ROLES.PSOPPCMANAGER.name, USER_ROLES.PSOPPCMANAGER.includes)}
                                                                name={role.name}
                                                                value={USER_ROLES.PSOPPCMANAGER.value}
                                                                onChange={(e) => handleRoleInputRadioChange(roleInputDispatch, e)}
                                                                checked={USER_ROLES.PSOPPCMANAGER.value == role.value}
                                                                //isInvalid={role.validation.isInvalid == true ? "invalid" : ""}
                                                                //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                ref={role.InputRef}
                                                            />
                                                        </>
                                                        : null
                                                    }

                                                    {orgTypeId == 21
                                                        ? <>
                                                            <Form.Check
                                                                key={"roleIdAHRQUser"}
                                                                type="radio"
                                                                id={"roleIdAHRQUser"}

                                                                label={getFullUserRoleName(USER_ROLES.AHRQUSER.name, USER_ROLES.AHRQUSER.includes)}
                                                                name={role.name}
                                                                value={USER_ROLES.AHRQUSER.value}
                                                                onChange={(e) => handleRoleInputRadioChange(roleInputDispatch, e)}
                                                                checked={USER_ROLES.AHRQUSER.value == role.value}
                                                                //isInvalid={role.validation.isInvalid  == true ? "invalid" : ""}
                                                                //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                ref={role.InputRef}
                                                            />
                                                            <Form.Check
                                                                key={"roleIdAHRQManager"}
                                                                type="radio"
                                                                id={"roleIdAHRQManager"}

                                                                label={getFullUserRoleName(USER_ROLES.AHRQMANAGER.name, USER_ROLES.AHRQMANAGER.includes)}
                                                                name={role.name}
                                                                value={USER_ROLES.AHRQMANAGER.value}
                                                                onChange={(e) => handleRoleInputRadioChange(roleInputDispatch, e)}
                                                                checked={USER_ROLES.AHRQMANAGER.value == role.value}
                                                                //isInvalid={role.validation.isInvalid  == true ? "invalid" : ""}
                                                                //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                                //disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                                                ref={role.InputRef}
                                                            />
                                                        </>
                                                        : null
                                                    }






                                                </Col>
                                                <Form.Control.Feedback className={role.validation.isInvalid != false ? "is-invalid" : ""} type="invalid">
                                                    {displayErrors(role.name, role.validation.errors)}
                                                </Form.Control.Feedback>

                                            </Form.Group>
                                        </fieldset>

                                        {orgTypeId == 24 || orgTypeId == 25 || orgTypeId == 21
                                            ? <>
                                                <FormInputDisplay fieldData={accountRolesAdditionalAccess} inputDispatch={accountRolesAdditionalAccessInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 12 }, inputCols: { lg: 5 } }}></FormInputDisplay>

                                                {/*<Form.Group as={Row} className="mb-3 accountRolesInput">
                                                            <Col hidden={false}
                                                                xs={12}
                                                                
                                                            >
                                                                <legend>
                                                                    {<span className="me-2">Additional Access (optional)</span>}
                                                                </legend>
                                                            </Col>
                                                                
                                                            <Col
                                                                xs={12}
                                                              
                                                            >

                                                                <Form.Check
                                                                        key={"collabSiteAccess"}
                                                                        type="checkbox"
                                                                        id={"collabSiteAccess"}
                                                                        
                                                                        label={"PSO Collaboration Community Access"}
                                                                        name={"accessToCollabSite"}
                                                                        value={""}
                                                                        onChange={(e) => handleInputCheckChange(roleCheckInputDispatch, e)}
                                                                        checked={roleCheck.sftpRoleForPSOAdmin}
                                                                        
                                                                />
                                                                
                                                            </Col>
                                                        </Form.Group>*/}
                                            </>
                                            : null
                                        }


                                        {/*
                                            roleId

                                            Level 1
                                                RD - Level 1 (PSO Collaboration Community Access)

                                            Level 2
                                                RD - Level 2 (PSO Profile)

                                            Level 3
                                                RD - Level 3 (PSO Profile, Patient Safety Data)
                                                    CK - Receive SFTP Email
                                                    CK - Change WS Password

                                            PSO Administrator
                                                RD - PSO Administrator (PSO Profile, Patient Safety Data, Vendor Authorization)
                                                    CK - Receive SFTP Email
                                                    Ck - Change WS Password

                                            PSOPPC Administrator
                                                RD - PSOPPC Administrator (PSO Profile, Vendor Authorization, Organization Administrator, Submission Management Report)

                                            PSOPPC Manager
                                                RD - PSOPPC Manager (Account Status Report, Submission Management Report)

                                            AHRQ User
                                                RD - AHRQ User (PSO Collaboration Community Access)

                                            AHRQ Manager
                                                RD - AHRQ Manager (Access Interactive Report)

                                            Additional Access (optional)
                                                CK - PSO Collaboration Community Access

                                        */}
                                        <h2>User Information</h2>
                                        <FormInputDisplay fieldData={userFirstName} inputDispatch={userFirstNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userMiddleName} inputDispatch={userMiddleNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userLastName} inputDispatch={userLastNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userPrefix} inputDispatch={userPrefixInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userSuffix} inputDispatch={userSuffixInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userCredentials} inputDispatch={userCredentialsInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userJobTitle} inputDispatch={userJobTitleInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userAddress1} inputDispatch={userAddress1InputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userAddress2} inputDispatch={userAddress2InputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userCity} inputDispatch={userCityInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userState} inputDispatch={userStateInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userZip} inputDispatch={userZipInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} pattern={NUMBER_PATTERN}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userZipExt} inputDispatch={userZipExtInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} pattern={NUMBER_PATTERN}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userPhone} inputDispatch={userPhoneInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userPhoneExt} inputDispatch={userPhoneExtInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} pattern={NUMBER_PATTERN}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userFax} inputDispatch={userFaxInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userEmailAddress} inputDispatch={userEmailAddressInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userConfirmEmailAddress} inputDispatch={userConfirmEmailAddressInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>

                                        {orgTypeId == 24 || orgTypeId == 26
                                            ? <>
                                                <h2>Contact Type</h2>
                                                <p>Select contact roles, or leave blank if this person should not be listed as a contact.</p>
                                                <FormInputDisplay fieldData={userContactType} inputDispatch={userContactTypeInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={true} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                            </>
                                            : null
                                        }

                                        <h2>Enter Password</h2>

                                        <FormInputDisplay fieldData={userPassword} inputDispatch={userPasswordInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 12, md: 8 }, inputCols: { lg: 5 } }}></FormInputDisplay>

                                        {/*<FormTextInput orgType={orgType} fieldName="contactVerify" hideLabel={true} horizontalForm={{is: true, labelCols: {lg:8, md:4}, inputCols: {lg:8}}} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>*/}

                                        <Stack className="pt-3" direction="horizontal" gap={3}>
                                            {/* Submit Button */}
                                            <TextButton
                                                variant="normal"
                                                onClick={handleSubmit}
                                                content={"Submit"}
                                            >
                                            </TextButton>

                                            {/* Cancel Button */}
                                            <TextButton
                                                variant="outline"
                                                onClick={handleCancel}
                                                content={"Cancel"}
                                            >
                                            </TextButton>
                                        </Stack>




                                    </Form>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            }
            {/*<Link tabIndex={0} className="btn btn-cancel" title={"Click the link to edit the information of "} to={{
                                                    pathname: "/manage",
                                                    }} state={{status: STATUSES.SUCCESS, modal: 
                                                        {
                                                            title: "Success!",
                                                            msg: "Organization has been sucessfully added."
                                                        } , orgType: orgType}} >Test Success popup</Link>*/}
        </Row>
    );
}



export default EditUser;